export const LOAD_CONTENT = 'mp/checkout/redirect/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'mp/checkout/redirect/DL_PAGE_LOADED';

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/QuickCheckout/redirect/redirect.js
 **/